type NotificationPreferencesProps = {
    activatePushNotifications: boolean;
    getUnreadDailyNotification: boolean;
    getUrgentMessageNotification: boolean;
    getDailySummaryNotification: boolean;
};

class NotificationPreferences {
    activatePushNotifications;

    getUnreadDailyNotification;

    getUrgentMessageNotification;

    getDailySummaryNotification;

    constructor({
        activatePushNotifications,
        getUnreadDailyNotification,
        getUrgentMessageNotification,
        getDailySummaryNotification,
    }: NotificationPreferencesProps) {
        this.activatePushNotifications = activatePushNotifications;
        this.getUnreadDailyNotification = getUnreadDailyNotification;
        this.getUrgentMessageNotification = getUrgentMessageNotification;
        this.getDailySummaryNotification = getDailySummaryNotification;
    }
}

export default NotificationPreferences;
